import type { CredentialRow, DomainRow, InvitationRow, UserRow } from "../../contracts/index";
import { IssueCredentialDialog, RevokeCredentialDialog } from "./CredentialDialogs";
import { AddDomainDialog, RemoveDomainDialog } from "./DomainDialogs";
import { InviteDialog } from "./InviteDialog";
import { RevokeInvitationDialog } from "./RevokeInvitationDialog";
import { RoleDialog } from "./RoleDialog";
import { DeactivateDialog, ReactivateDialog } from "./UserStatusDialogs";

export type DialogState =
  | { kind: "invite" }
  | { kind: "role"; user: UserRow }
  | { kind: "deactivate"; user: UserRow }
  | { kind: "reactivate"; user: UserRow }
  | { kind: "revoke"; invitation: InvitationRow }
  | { kind: "addDomain" }
  | { kind: "removeDomain"; domain: DomainRow }
  | { kind: "issueCredential" }
  | { kind: "revokeCredential"; credential: CredentialRow }
  | null;

export function AccessDialogs({ dialog, onClose }: { dialog: DialogState; onClose: () => void }) {
  return (
    <>
      {dialog?.kind === "invite" ? <InviteDialog onClose={onClose} /> : null}
      {dialog?.kind === "role" ? <RoleDialog user={dialog.user} onClose={onClose} /> : null}
      {dialog?.kind === "deactivate" ? <DeactivateDialog user={dialog.user} onClose={onClose} /> : null}
      {dialog?.kind === "reactivate" ? <ReactivateDialog user={dialog.user} onClose={onClose} /> : null}
      {dialog?.kind === "revoke" ? <RevokeInvitationDialog invitation={dialog.invitation} onClose={onClose} /> : null}
      {dialog?.kind === "addDomain" ? <AddDomainDialog onClose={onClose} /> : null}
      {dialog?.kind === "issueCredential" ? <IssueCredentialDialog onClose={onClose} /> : null}
      {dialog?.kind === "revokeCredential" ? (
        <RevokeCredentialDialog credential={dialog.credential} onClose={onClose} />
      ) : null}
      {dialog?.kind === "removeDomain" ? <RemoveDomainDialog domain={dialog.domain} onClose={onClose} /> : null}
    </>
  );
}
